const baseUrl = process.env.VUE_APP_API_TRUST;

const endpoints = {
  // Authentication
  login: "login",

  // account
  getProfile: "profile",
  getNotification: "notifications/get",
  markReadNotification: "notifications/mark-as-read",
  switchAccount: "account-switch",
  requestOtp: "request-otp",
  regisSubAccount: "register/subaccount",
  uploadPP: "upload-pp",
  changePassword: "change-password",
  updateUser: "update-user",

  // general
  getPlant: "plant/get",
  getPlanQueue: "plant/get-lab-queue",
  getGender: "gender/get",
  getSubDistrict: "subdistrict/get",
  getDistrict: "district/get",
  getCity: "city/get",
  getProvince: "province/get",
  getCountry: "country/get",
  getIdentityType: "identity-type/get",
  getReligion: "religion/get",
  getMaritalStatus: "marital-status/get",
  getEthnicity: "ethnicity/get",
  getNeoDistance: "geo/distance-search",

  // product
  getProductTestCategory: "product-test-category/get",
  getProductCategory: "product/get-category",
  getProductSubCategory: "product-subcategory/get",
  getProduct: "product/get",
  getProductSymptom: "product/get-symptom",
  getTopProduct: "statistic/get-topproduct",
  getProductRelated: "product-related/get",
  getProductRecommendation: "product/get-recommendation",

  // package
  getPackage: "package/get",
  getPackageSubscription: "package/subscription",
  getRelatedPackage: "related-package/get",

  // subscrioption
  getSubscription: "subscription/get", // type=package or type=product
  getDetailDeal: "deal/get-detail",
  getDeal: "deal/get",
  useSubscription: "subscription/use",

  // helper
  getDataRescheduleDefault: "get-defaults",

  // patient
  // family
  getPatientRelated: "patient-related/list",
  getPatientRelatedType: "patient-related/get-rel-type",
  addPatientRelated: "patient-related/add",
  searchPatientRelated: "patient-related/search-id",
  deletePatientRelated: "patient-related/delete",
  confirmPatientRelated: "patient-related/confirm",

  // homecare
  getAvailableSchedule: "homecare/available-schedule",
  bookHomecare: "registration/book-homecare",
  joinHomecare: "registration/join-homecare",
  getServicePriceHomecare: "homecare/get-service-price",

  // telemedecine
  getDoctorList: "doctor/list",
  getTelemedecineDoctor: "telemedicine/doctors",
  insertTelemedecine: "telemedicine/insert",
  getScheduleTelemedecine: "telemedicine/schedule",
  getDetailTelemedecine: "telemedicine/get-detail",

  // order
  getCart: "cart/get",
  storeCart: "cart/store",
  emptyCart: "cart/empty",
  getOrderList: "registration/get-order-list",
  getOrderDetail: "registration/get-order-detail",
  reschedule: "registration/reschedule",
  shareOrder: "registration/share-order",
  getSharingList: "registration/get-sharing-list",
  getSharingRecipient: "registration/get-sharing-recipients",
  createSharing: "registration/create-sharing",
  updateSharing: "registration/update-sharing",
  getMySubscription: "subscription/get-detail",
  validationBook: "registration/validation-book",
  getDetailVoucher: "voucher/detail-voucher-code",
  getDiscount: "discount/get",
  applyDiscount: "discount/apply",
  buyPackageSub: "subscription/buy-package",
  checkStatusOrder: "registration/status-transaction",
  bookRegistration: "registration/book",
  buyPackage: "registration/buy-package",

  // company
  updateProfileCompany: "company/update-profile",
  getMcuFinalResult: "mcu-final-result/get",
  getJobPosition: "job-position/get",
  approveSharingTransaction: "registration/approve-sharing",
  updateTax: "company/update-tax",
  getBookYearFilter: "employee/get-booking-year",
  getBookingStatusFilter: "employee/get-booking-status",
  // insurance
  getDepartmentPatientInsurance: "patient-insurance/get-department",

  // contact
  deleteContact: "contact/delete",
  setPrimaryContact: "contact/make-primary",
  updateContact: "contact/update",
  insertContact: "contact/insert",
  getContact: "contact/get",

  // bank account
  getBankAccountList: "bank-account/list-bank",
  addBankAccount: "bank-account/add",
  deleteBankAccount: "bank-account/delete",
  setPrimaryBankAccount: "bank-account/set-primary",
  updateBankAccount: "bank-account/update",
  getBankAccount: "bank-account/get",

  // business partner
  getBusinessPartner: "business-partner/get",
  getBusinessPartnerContract: "business-partner-contract/get",
  renewalBusinessPartnerContract: "business-partner-contract/renewal",
  transferBusinessPartnerContract: "business-partner-contract/transfer",
  transferlistBusinessPartnerContract:
    "business-partner-contract/list-transfer",

  // order
  employeeReschedule: "employee/reschedule-booking",
  employeeGetContract: "employer/get-contract",

  // employee
  getEmployee: "employee/get",
  addEmployee: "employee/add",
  bookingEmployee: "employee/book",
  deleteEmployee: "employee/delete",
  updateEmployee: "employee/update",
  validattionApprovalEmployee: "employee/validation-approval",
  approveTransactionEmployee: "employee/approve-transaction",
  cancelBookingEmployee: "employee/cancel-booking",
  getEmployeeBooking: "employee/get-booking-detail",

  // doctor
  updateDoctor: "doctor/update",
  getWorkPlace: "doctor/get-workplaces",
  // licence
  getLicenceDoctor: "license/get",
  deleteLicenceDoctor: "license/delete",
  updateLicenceDoctor: "license/update",
  addLicenceDoctor: "license/add",

  // education
  getEducation: "education/get",
  updateEducation: "education/update",
  // telemedecine
  getListTelemedecineAppointment: "telemedicine/list-appointment",
  // referal
  getReferalOrderList: "referral/get-order",
  getReferalRevenue: "referral/get-revenue",
  getReferalInvoiceSpecimen: "referral/get-invoice-specimen",
  getReferalFeeDoctor: "referral/get-fees-from-doctor",
  getReferalFeePattientList: "referral/get-fees-patient-list",

  // lab results
  labRessultAdvancedChartData: "lab-results/get-advance-chart-data",
  labResultGetDetail: "lab-results/get-detail",
  labResultGetProductPerItemList: "lab-results/get-product-item-list",
  labResultGetProductPerItemResult: "lab-results/get-product-item-result",

  // report
  downloadLabReport: "diagnosis/get-labreport",
  getMcuReport: "diagnosis/get-mcureport",
  getDiagnosisHistory: "diagnosis/get-history",

  // invoice
  getDetailInvoice: "invoices/get-detail",
  getPrintoutInvoice: "invoices/get-printout",
  getCompanyInvoice: "invoices/get-invoice-company",
  getCompanyPrintoutInvoice: "invoices/get-invoice-company-printout",
  saveRating: "invoices/save-rating",
  getInvoiceAllPayment: "invoices/get-all-payments",
  getInvoicePaidPayment: "invoices/get-paid-payments",
  getInvoiceQrCode: "invoices/get-qr-code",

  // medical record
  getDetailInspectionMedicalRecord: "medical-record/inspection/detail",
  getListInspectionMedicalRecord: "medical-record/inspection/list",
  getVirtalityMedicalRecord: "medical-record/vitality-sign-by-medical-record",
  getVirtalityFilter: "medical-record/vitality-sign-column-filter",
  getMcuMedicalRecord: "medical-record/mcu-record/get-all-mcu",
  getVirtalityChart: "medical-record/vitality-sign-chart",
  getMedicalRecordGrouped: "medical-record/get-grouped",
};

// Create full API URL using map
const ApiUrl = Object.fromEntries(
  Object.entries(endpoints).map(([key, value]) => [key, `${baseUrl}${value}`])
);

export default ApiUrl;
